/* eslint no-use-before-define: 0 */

const { $ } = window;

export default class CarouselComponent {
    /**
     *
     * @param {Object} carouselNode - Jquery DOM node
     */
    constructor(carouselNode) {
        this.currentSlideIndex = 0;
        this.carouselNode = carouselNode;
        this.slickConfig = null;
        this.HTMLconfiguration = null;

        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        const scope = this;

        parseConfigurationFromHTML();
        initSlickCarousel();
        if (this.HTMLconfiguration.isPopupViwerEnalbed && !this.HTMLconfiguration.isExperienceEditor) {
            initFancyboxPopupViewer();
        }

        function parseConfigurationFromHTML() {
            const node = scope.carouselNode;
            scope.HTMLconfiguration = {
                isExperienceEditor: !!parseInt($("#current-sitecore-context").data("ee"), 10),
                amountSlidesDesktop: parseInt(node.data("amount-desktop"), 10),
                amountSlidesMobile: parseInt(node.data("amount-mobile"), 10),
                totalAmountSlides: parseInt(node.data("total-amount-images"), 10),
                isPopupViwerEnalbed: node.data("is-popup-viewer-enabled") === "True",
                imagesForPopupViewer: node
                    .parent()
                    .find(".popup-viewer-datasource-section")
                    .eq(0)
                    .find("a"),
            };
        }

        function initSlickCarousel() {
            setOnSlickCarouselReadyActions();
            saveIndexWhenChanged();
            scope.slickConfig = createSlickCarouselConfiguration();
            scope.carouselNode.slick(scope.slickConfig);

            function saveIndexWhenChanged() {
                scope.carouselNode.on("afterChange", (event, slick, currentSlide) => {
                    scope.currentSlideIndex = currentSlide;
                });
            }

            function setOnSlickCarouselReadyActions() {
                scope.carouselNode.on("init", () => {
                    scope.carouselNode.css("visibility", "visible");
                    scope.carouselNode.addClass("ready");
                });
            }

            /**
             * @returns {Object}
             */
            function createSlickCarouselConfiguration() {
                const configuration = {
                    lazyLoad: "ondemand",
                    dots: false, // Current slide indicator dots
                    infinite: true, // Infinite looping
                    slidesToShow: scope.HTMLconfiguration.amountSlidesDesktop,
                    slidesToScroll: 1,
                };

                if (scope.HTMLconfiguration.amountSlidesMobile > 0) {
                    configuration.responsive = [
                        {
                            breakpoint: 768,
                            settings: {
                                dots: false,
                                infinite: true,
                                slidesToShow: scope.HTMLconfiguration.amountSlidesMobile,
                                slidesToScroll: 1,
                                adaptiveHeight: false,
                                arrows: scope.HTMLconfiguration.totalAmountSlides > 1,
                                swipe: scope.HTMLconfiguration.totalAmountSlides > 1,
                            },
                        },
                    ];
                }

                return configuration;
            }
        }


        function initFancyboxPopupViewer() {
            const btnOpenPopupViewer = scope.carouselNode.next();
            btnOpenPopupViewer.on("click", () => {
                /**
                 * We want to start from center slide
                 */
                let index = scope.currentSlideIndex;
                if (scope.HTMLconfiguration.amountSlidesDesktop > 2) {
                    index += Math.floor(scope.HTMLconfiguration.amountSlidesDesktop / 2);
                    if (scope.HTMLconfiguration.amountSlidesDesktop % 2 === 0) {
                        index -= 1;
                    }
                }
                index %= scope.HTMLconfiguration.totalAmountSlides;
                $.fancybox.open(scope.HTMLconfiguration.imagesForPopupViewer, createFancyboxConfiguration(), index);
            });

            function createFancyboxConfiguration() {
                return {
                    buttons: [
                        "close",
                    ],
                    loop: true,
                    keyboard: true,
                    arrows: true,
                };
            }
        }
    }
}
